import * as React from 'react';
import * as Metadata from "../../entities/Metadata";
import { ConfirmationDialog } from '../common/ConfirmationDialog';
import { RouteComponentProps, withRouter } from "react-router-dom";
import { KeyDate } from '../../entities/Subentities';
import { connect } from 'react-redux';
import { Dictionary, EntityType } from '../../entities/common';
import { ApplicationState } from '../../store';

type OwnProps = {
    onConfirm: () => void;
    onDismiss: () => void;
    selectedItems: KeyDate[];
}
type StoreProps = {
    fieldsMap: Dictionary<Metadata.Field>;
}
type Props = OwnProps & StoreProps & RouteComponentProps<{}>;
const KeyDateSetBeselineConfirmation = (props: Props) => <ConfirmationDialog
    onDismiss={props.onDismiss}
    onYes={props.onConfirm}
    yesButtonProps={{ text: "Confirm" }}
    dialogContentProps={{
        title: `Set Baseline`,
        subText:
            (props.selectedItems.length === 1
                ? `Are you sure you want to create a baseline for key date "${props.selectedItems[0].attributes.Name}"?`
                : `Are you sure you want to create a baseline for selected key dates (${props.selectedItems.length} items)?`)
    }}>
    This action will take a snapshot of a Date on selected items    
</ConfirmationDialog>;

function mapStateToProps(state: ApplicationState, ownProps: OwnProps): StoreProps {
    const fields = state.fields[EntityType.KeyDate];
    return {
        fieldsMap: Metadata.toMap(fields.allIds.map(_ => fields.byId[_]))
    };
}
export default withRouter<OwnProps>(connect(mapStateToProps)(KeyDateSetBeselineConfirmation));